<template>
    <div class="find-a-doctor-active-filters" v-if="hasFilters">
        <div class="find-a-doctor-active-filters__label">
            {{ label }}:
        </div>
        <ul class="find-a-doctor-active-filters__filters">
            <li
                class="find-a-doctor-active-filters__filter"
                tabindex="0"
                v-for="(filter, key) in filters"
                :key="key"
                v-if="filter.value.length || (typeof filter.value === 'boolean' && filter.value !== false) "
            >
                <div class="find-a-doctor-active-filters__filter-name">
                    <template v-if="filter.label && filter.value && filter.valueOnly !== true && filter.labelOnly !== true">
                        {{ filter.label }}: {{ filter.value }}
                    </template>
                    <template v-if="filter.label && filter.labelOnly">
                        {{ filter.label }}
                    </template>
                    <template v-if="filter.value && filter.valueOnly">
                        {{ filter.value }}
                    </template>
                    <!-- <template v-if="filter.label !== false && filter.showValue !== false ">
                        {{ filter.label }}: {{ filter.value }}
                    </template>
                    <template v-else-if="filter.label && filter.showValue === false && filter.value.length">
                        {{ filter.label }}
                    </template>
                    <template v-else-if="filter.showValue === true">
                        {{ filter.value }}
                    </template> -->
                </div>
                <button
                    type="button"
                    class="icon -close find-a-doctor-active-filters__filter-close"
                    v-if="filter.clearable"
                    @click="resetFilter(filter.filter)"
                >
                    <span class="sr-only">Remove filter</span>
                </button>
            </li>
        </ul>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        filters: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        ...mapActions(['resetFilter']),
    },
    computed: {
        hasFilters() {
            for (let i = 0; i < this.filters.length; i++) {
                if (this.filters[i].value !== '') {
                    return true;
                }
            }

            return false;
        }
    },
};
</script>
